import { Modal } from "antd";
import React, { useEffect, useState } from "react";
import { useInterviewRoundContext } from "../../../../Context/InterviewRoundContext";

interface ExitFullScreenConfirmationProps {
  handleConfirmExit: () => void;
  containerRef: React.RefObject<HTMLDivElement> | null;
  isFullscreen: boolean;
  showExitConfirmation: boolean;
  setShowExitConfirmation: (value: boolean) => void;
  handleCancelExit: () => void;
  exitTimer: boolean;
}

const ExitFullScreenConfirmation: React.FC<ExitFullScreenConfirmationProps> = ({
  handleConfirmExit,
  containerRef,
  showExitConfirmation,
  handleCancelExit,
  exitTimer,
}) => {
  const { exitFullscreenMessage, exitConfirmationModalRef } =
    useInterviewRoundContext();
  const [countdown, setCountdown] = useState(5);

  // Countdown effect
  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (exitTimer && showExitConfirmation) {
      setCountdown(5); // Reset
      interval = setInterval(() => {
        setCountdown((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            handleConfirmExit();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [exitTimer, showExitConfirmation]);

  return (
    <div ref={exitConfirmationModalRef}>
      <Modal
        title="Exit Fullscreen Mode?"
        open={showExitConfirmation}
        onOk={handleConfirmExit}
        onCancel={handleCancelExit}
        okText={exitTimer ? `Exit (${countdown})` : "Exit"}
        cancelText="Stay"
        okButtonProps={{ danger: true }}
        centered
        maskClosable={false}
        closeIcon={false}
        getContainer={() => containerRef?.current!}
      >
        <p>
          {exitFullscreenMessage
            ? exitFullscreenMessage
            : "Are you sure you want to exit fullscreen mode? This may result in disqualification from the interview."}
        </p>
      </Modal>
    </div>
  );
};

export default ExitFullScreenConfirmation;
